var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWineDetailsColourV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8241 16.1285L11.4005 3.28125L4.97686 16.1285C4.4542 17.1299 4.15771 18.2684 4.15771 19.476C4.15771 23.4762 7.40029 26.7188 11.4005 26.7188C15.4007 26.7188 18.6433 23.4762 18.6433 19.476C18.6433 18.2684 18.3474 17.1299 17.8241 16.1285Z",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2281 15.8467L20.4105 6.21094L16.6377 13.7561L17.8236 16.1285C18.3463 17.1299 18.6428 18.2684 18.6428 19.476C18.6428 20.7809 18.2977 22.0043 17.6941 23.0619C18.4934 23.5242 19.4209 23.7891 20.4105 23.7891C23.4105 23.7891 25.8428 21.3568 25.8428 18.3568C25.8428 17.451 25.6207 16.5973 25.2287 15.8461L25.2281 15.8467Z",
    fill: "#150036",
    stroke: "#150036",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWineDetailsColourV2);
export default __webpack_public_path__ + "static/media/wine-details-colour-V2.c3aca126c1f75a35e1126afbb5f67f18.svg";
export { ForwardRef as ReactComponent };